import LoaderSvg from '@assets/images/svg/loader.svg';
import React from 'react';
import { View } from 'react-native';

export interface LoaderIconProps {
  size?: number;
  color?: string;
}

/** Figma reservation in-progress — 8-ray loader (19×19) */
export function LoaderIcon({
  size = 19,
  color = '#BF8C08',
}: Readonly<LoaderIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoaderSvg width={size} height={size} color={color} />
    </View>
  );
}

export default LoaderIcon;
